import dayjs from "dayjs";

const filterAvailableFromDates = (
  orderItems: {
    availableFrom: Date | null;
  }[],
) =>
  orderItems.map((item) => item.availableFrom).filter((date) => !!date) ?? [];

const findLatestDate = (dates: Date[]): Date | null => {
  if (dates.length === 0) return null;

  const latestTimestamp = Math.max(
    ...dates.map((date) => new Date(date).getTime()),
  );

  return new Date(latestTimestamp);
};

export const findLatestPreOrderAvailableFromDate = (
  orderItems: {
    availableFrom: Date | null;
  }[],
  referenceDate: Date = new Date(),
): Date | null => {
  const availableFromDates = filterAvailableFromDates(orderItems);
  const latestAvailableFromDate = findLatestDate(availableFromDates);

  if (
    latestAvailableFromDate &&
    dayjs(referenceDate).isBefore(latestAvailableFromDate, "day")
  ) {
    return dayjs(latestAvailableFromDate).startOf("day").toDate();
  }

  return null;
};
